import React from "react";
import { FaBug, FaCode, FaServer, FaChartBar } from "react-icons/fa";

const skillGroups = [
  {
    category: "QA & Testing",
    icon: <FaBug size={15} />,
    skills: [
      "Manual Testing",
      "API Testing",
      "Playwright",
      "Cypress",
      "Selenium",
      "Test Planning",
      "Bug Reporting",
    ],
  },
  {
    category: "Frontend",
    icon: <FaCode size={15} />,
    skills: ["HTML", "CSS", "JavaScript", "React", "Tailwind CSS", "Bootstrap"],
  },
  {
    category: "Backend & Tools",
    icon: <FaServer size={15} />,
    skills: [
      "PHP",
      "Node.js",
      "REST APIs",
      "Git",
      "GitHub",
      "Firebase",
      "MongoDB",
      "Postman",
    ],
  },
  {
    category: "Product",
    icon: <FaChartBar size={15} />,
    skills: [
      "Product Management",
      "User Stories",
      "Agile / Scrum",
      "Stakeholder Communication",
    ],
  },
];

const Skills = () => {
  return (
    <section name="skills" className="w-full bg-[#2F4156] py-12">
      <div className="max-w-5xl mx-auto px-6">
        <div className="mb-16">
          <p className="text-sm font-medium text-[#C8D9E6] tracking-widest uppercase mb-3">
            Capabilities
          </p>
          <h2 className="text-4xl font-bold text-[#F5EFEB]">Skills</h2>
        </div>

        <div className="grid sm:grid-cols-2 gap-10">
          {skillGroups.map(({ category, icon, skills }) => (
            <div key={category}>
              <div className="flex items-center gap-2 text-[#C8D9E6] mb-4">
                {icon}
                <p className="text-xs font-semibold uppercase tracking-widest">
                  {category}
                </p>
              </div>
              <div className="flex flex-wrap gap-2">
                {skills.map((skill) => (
                  <span
                    key={skill}
                    className="text-sm font-medium bg-[#567C8D] text-[#F5EFEB] px-4 py-2 rounded-full hover:bg-[#C8D9E6] hover:text-[#2F4156] transition-colors"
                  >
                    {skill}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;
